module.exports = __webpack_public_path__ + "static/media/login.24a72e43.jpg";